var base = require('settings/teams/send-invitation');

Vue.component('spark-send-invitation', {
    mixins: [base],
    props: {
        defaultContent: {
            default: '',
        },
        defaultTitle: {
            default: '',
        },
        defaultButton: {
            default: '',
        },
    },
    data() {
        return {
            showModal: false,
            form: new SparkForm({
                name: null,
                title: null,
                button: null,
                content: null,
                email: '',
                role: this.defaultRole,
            }),
        };
    },
    created() {
        this.form.title = this.defaultTitle;
        this.form.button = this.defaultButton;
        this.form.content = this.defaultContent;
    },
    methods: {
        /**
         * Send a team invitation.
         */
        send() {
            Spark.post(`/settings/teams/${this.team.id}/invitations`, this.form).then(() => {
                this.form.email = '';
                this.form.name = '';
                this.form.content = this.defaultContent;
                this.form.button = this.defaultButton;
                this.form.title = this.defaultTitle;
                this.form.role = Spark.defaultRole;
                this.showModal = false;
                this.$parent.$dispatch('updateInvitations');
            });
        },

        openTemplate() {
            this.showModal = true;
        },
    },
});
